<div class="w-full">
  <h2 class="text-xl font-medium mb-4 md:px-6 lg:hidden">Empleos Top</h2>
  <div
    class="flex space-x-4 pb-4 overflow-x-auto scrolling-touch lg:hidden snap-x snap-mandatory"
  >
    @if (isLoading) { @for (item of [].constructor(4); track $index) {
    <div
      class="shrink-0 w-60 h-56 bg-gray-100 rounded-lg animate-pulse p-4 snap-center flex flex-col"
    >
      <div class="flex justify-between items-start mb-4">
        <div class="w-10 h-10 bg-gray-300 rounded-md"></div>
        <div class="w-12 h-5 bg-gray-300 rounded"></div>
      </div>
      <div class="grow min-h-0">
        <div class="w-4/5 h-6 bg-gray-300 rounded mb-3"></div>
        <div class="w-3/5 h-4 bg-gray-200 rounded mb-4"></div>
        <div class="flex gap-2 mb-auto">
          <div class="w-16 h-3 bg-gray-200 rounded"></div>
          <div class="w-16 h-3 bg-gray-200 rounded"></div>
        </div>
      </div>
      <div class="w-24 h-8 bg-gray-300 rounded mt-auto"></div>
    </div>
    } } @else { @for (job of jobs; track job) {
    <div
      class="shrink-0 w-60 h-56 bg-white rounded-lg shadow-md p-4 border border-gray-200 snap-center flex flex-col"
    >
      <div class="grow min-h-0">
        <div class="flex justify-between items-start mb-2">
          <img
            [src]="companyImage(job)"
            alt="Logo"
            class="w-10 h-10 object-cover rounded-md shadow"
          />
          @if(ShowSalary(job)) {
          <div class="text-sm font-bold text-black whitespace-nowrap">
            {{ job.salary | solesCurrency }}
          </div>
          }
        </div>
        <h3 class="font-bold text-lg text-gray-800 line-clamp-2">
          {{ job.title }}
        </h3>
        <p class="text-sm font-medium text-primary truncate mb-2">
          {{ job.companyName }}
        </p>
        <div class="flex flex-wrap items-center gap-2 text-xs text-gray-500">
          <span class="px-2 py-0.5 bg-gray-100 rounded-full">
            {{ job.visitsNumber | shortNumber }} vistas
          </span>
          <span class="px-2 py-0.5 bg-gray-100 rounded-full">
            {{ job.publicationDate | timeAgo }}
          </span>
        </div>
      </div>
      <button
        [routerLink]="['/job', job.id]"
        class="text-sm font-medium px-4 py-1 bg-primary text-white rounded hover:bg-primary/90 transition mt-auto"
      >
        Ver empleo
      </button>
    </div>
    } }
  </div>
  <div
    class="hidden lg:block rounded-md top-5 max-h-[100vh] sticky overflow-y-auto bg-white shadow p-4"
  >
    <h2 class="text-xl font-medium mb-4 px-2">Empleos Top</h2>
    @if (isLoading) { @for (item of [].constructor(3); track $index) {
    <div class="py-3 animate-pulse">
      <div class="mb-2 mt-0 p-4 space-y-3 border border-gray-100 rounded-lg">
        <div class="flex justify-between items-start mb-2">
          <div class="w-10 h-10 bg-gray-300 rounded-md"></div>
          <div class="w-12 h-4 bg-gray-300 rounded"></div>
        </div>
        <div class="space-y-1">
          <div class="w-full h-4 bg-gray-300 rounded"></div>
          <div class="w-3/5 h-3 bg-gray-200 rounded"></div>
        </div>
        <div
          class="flex justify-between items-center pt-2 border-t border-gray-100"
        >
          <div class="w-24 h-6 bg-gray-300 rounded"></div>
          <div class="flex gap-2 text-xs justify-end">
            <div class="w-16 h-5 bg-gray-200 rounded-full"></div>
            <div class="w-16 h-5 bg-gray-200 rounded-full"></div>
          </div>
        </div>
      </div>
    </div>
    } } @else {
    <div>
      @for (job of jobs; track job) {
      <div
        class="mb-3 bg-white rounded-lg px-4 py-3 border border-gray-200 hover:bg-gray-50 transition"
      >
        <div class="flex flex-col gap-2">
          <div class="flex justify-between items-start">
            <div class="shrink-0">
              <img
                [src]="companyImage(job)"
                alt="Logo"
                class="w-10 h-10 object-cover rounded-md shadow"
              />
            </div>
            @if(ShowSalary(job)) {
            <div class="text-sm text-black font-bold text-right shrink-0">
              {{ job.salary | solesCurrency }}
            </div>
            }
          </div>
          <div class="overflow-hidden min-w-0 mb-3">
            <h3 class="font-semibold truncate text-gray-800">
              {{ job.title }}
            </h3>
            <p class="text-sm text-gray-500 truncate">
              {{ job.companyName }}
            </p>
          </div>
        </div>
        <div class="flex justify-between items-center pt-2">
          <button
            [routerLink]="['/job', job.id]"
            class="border border-gray-400 text-gray-700 px-3 py-1 rounded hover:border-primary hover:text-primary cursor-pointer transition w-fit text-sm"
          >
            Ver detalles
          </button>

          <div
            class="flex items-center gap-2 text-xs text-gray-500 justify-end shrink-0"
          >
            <span
              class="px-2 py-1 bg-gray-100 text-gray-700 rounded-full font-medium"
            >
              {{ job.publicationDate | timeAgo }}
            </span>
          </div>
        </div>
      </div>
      }
    </div>
    }
  </div>
</div>
